export enum EffectivenessOriginType {
    new = 1,
    existing = 2,
    catalogue = 3
}
